import { CurvoErrorCode } from '../gen/models'

export const ERROR_MESSAGE_MAP: Record<CurvoErrorCode | string, string> = {
  INTERNAL_SERVER_ERROR: 'Something went wrong. Please contact our support to help you fix it.',
  QUICK_CREATE_ORG_DUP:
    'A Facility with that name already exists. Please select the existing one or enter a unique name to proceed.',
}
